export default {
  ITEM: 'item',
};
